/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Status, statusFromJSON, statusToJSON } from "./constants";

export const protobufPackage = "espressif";

export enum WiFiCtrlMsgType {
  TypeCtrlReserved = 0,
  TypeCmdCtrlReset = 1,
  TypeRespCtrlReset = 2,
  TypeCmdCtrlReprov = 3,
  TypeRespCtrlReprov = 4,
  UNRECOGNIZED = -1,
}

export function wiFiCtrlMsgTypeFromJSON(object: any): WiFiCtrlMsgType {
  switch (object) {
    case 0:
    case "TypeCtrlReserved":
      return WiFiCtrlMsgType.TypeCtrlReserved;
    case 1:
    case "TypeCmdCtrlReset":
      return WiFiCtrlMsgType.TypeCmdCtrlReset;
    case 2:
    case "TypeRespCtrlReset":
      return WiFiCtrlMsgType.TypeRespCtrlReset;
    case 3:
    case "TypeCmdCtrlReprov":
      return WiFiCtrlMsgType.TypeCmdCtrlReprov;
    case 4:
    case "TypeRespCtrlReprov":
      return WiFiCtrlMsgType.TypeRespCtrlReprov;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WiFiCtrlMsgType.UNRECOGNIZED;
  }
}

export function wiFiCtrlMsgTypeToJSON(object: WiFiCtrlMsgType): string {
  switch (object) {
    case WiFiCtrlMsgType.TypeCtrlReserved:
      return "TypeCtrlReserved";
    case WiFiCtrlMsgType.TypeCmdCtrlReset:
      return "TypeCmdCtrlReset";
    case WiFiCtrlMsgType.TypeRespCtrlReset:
      return "TypeRespCtrlReset";
    case WiFiCtrlMsgType.TypeCmdCtrlReprov:
      return "TypeCmdCtrlReprov";
    case WiFiCtrlMsgType.TypeRespCtrlReprov:
      return "TypeRespCtrlReprov";
    case WiFiCtrlMsgType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface CmdCtrlReset {
}

export interface RespCtrlReset {
}

export interface CmdCtrlReprov {
}

export interface RespCtrlReprov {
}

export interface WiFiCtrlPayload {
  msg: WiFiCtrlMsgType;
  status: Status;
  cmdCtrlReset?: CmdCtrlReset | undefined;
  respCtrlReset?: RespCtrlReset | undefined;
  cmdCtrlReprov?: CmdCtrlReprov | undefined;
  respCtrlReprov?: RespCtrlReprov | undefined;
}

function createBaseCmdCtrlReset(): CmdCtrlReset {
  return {};
}

export const CmdCtrlReset = {
  encode(_: CmdCtrlReset, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CmdCtrlReset {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCmdCtrlReset();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(_: any): CmdCtrlReset {
    return {};
  },

  toJSON(_: CmdCtrlReset): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<CmdCtrlReset>, I>>(base?: I): CmdCtrlReset {
    return CmdCtrlReset.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<CmdCtrlReset>, I>>(_: I): CmdCtrlReset {
    const message = createBaseCmdCtrlReset();
    return message;
  },
};

function createBaseRespCtrlReset(): RespCtrlReset {
  return {};
}

export const RespCtrlReset = {
  encode(_: RespCtrlReset, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RespCtrlReset {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRespCtrlReset();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(_: any): RespCtrlReset {
    return {};
  },

  toJSON(_: RespCtrlReset): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RespCtrlReset>, I>>(base?: I): RespCtrlReset {
    return RespCtrlReset.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<RespCtrlReset>, I>>(_: I): RespCtrlReset {
    const message = createBaseRespCtrlReset();
    return message;
  },
};

function createBaseCmdCtrlReprov(): CmdCtrlReprov {
  return {};
}

export const CmdCtrlReprov = {
  encode(_: CmdCtrlReprov, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CmdCtrlReprov {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCmdCtrlReprov();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(_: any): CmdCtrlReprov {
    return {};
  },

  toJSON(_: CmdCtrlReprov): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<CmdCtrlReprov>, I>>(base?: I): CmdCtrlReprov {
    return CmdCtrlReprov.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<CmdCtrlReprov>, I>>(_: I): CmdCtrlReprov {
    const message = createBaseCmdCtrlReprov();
    return message;
  },
};

function createBaseRespCtrlReprov(): RespCtrlReprov {
  return {};
}

export const RespCtrlReprov = {
  encode(_: RespCtrlReprov, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RespCtrlReprov {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRespCtrlReprov();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(_: any): RespCtrlReprov {
    return {};
  },

  toJSON(_: RespCtrlReprov): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RespCtrlReprov>, I>>(base?: I): RespCtrlReprov {
    return RespCtrlReprov.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<RespCtrlReprov>, I>>(_: I): RespCtrlReprov {
    const message = createBaseRespCtrlReprov();
    return message;
  },
};

function createBaseWiFiCtrlPayload(): WiFiCtrlPayload {
  return {
    msg: 0,
    status: 0,
    cmdCtrlReset: undefined,
    respCtrlReset: undefined,
    cmdCtrlReprov: undefined,
    respCtrlReprov: undefined,
  };
}

export const WiFiCtrlPayload = {
  encode(message: WiFiCtrlPayload, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.msg !== 0) {
      writer.uint32(8).int32(message.msg);
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status);
    }
    if (message.cmdCtrlReset !== undefined) {
      CmdCtrlReset.encode(message.cmdCtrlReset, writer.uint32(90).fork()).ldelim();
    }
    if (message.respCtrlReset !== undefined) {
      RespCtrlReset.encode(message.respCtrlReset, writer.uint32(98).fork()).ldelim();
    }
    if (message.cmdCtrlReprov !== undefined) {
      CmdCtrlReprov.encode(message.cmdCtrlReprov, writer.uint32(106).fork()).ldelim();
    }
    if (message.respCtrlReprov !== undefined) {
      RespCtrlReprov.encode(message.respCtrlReprov, writer.uint32(114).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WiFiCtrlPayload {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWiFiCtrlPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.msg = reader.int32() as any;
          break;
        case 2:
          message.status = reader.int32() as any;
          break;
        case 11:
          message.cmdCtrlReset = CmdCtrlReset.decode(reader, reader.uint32());
          break;
        case 12:
          message.respCtrlReset = RespCtrlReset.decode(reader, reader.uint32());
          break;
        case 13:
          message.cmdCtrlReprov = CmdCtrlReprov.decode(reader, reader.uint32());
          break;
        case 14:
          message.respCtrlReprov = RespCtrlReprov.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): WiFiCtrlPayload {
    return {
      msg: isSet(object.msg) ? wiFiCtrlMsgTypeFromJSON(object.msg) : 0,
      status: isSet(object.status) ? statusFromJSON(object.status) : 0,
      cmdCtrlReset: isSet(object.cmdCtrlReset) ? CmdCtrlReset.fromJSON(object.cmdCtrlReset) : undefined,
      respCtrlReset: isSet(object.respCtrlReset) ? RespCtrlReset.fromJSON(object.respCtrlReset) : undefined,
      cmdCtrlReprov: isSet(object.cmdCtrlReprov) ? CmdCtrlReprov.fromJSON(object.cmdCtrlReprov) : undefined,
      respCtrlReprov: isSet(object.respCtrlReprov) ? RespCtrlReprov.fromJSON(object.respCtrlReprov) : undefined,
    };
  },

  toJSON(message: WiFiCtrlPayload): unknown {
    const obj: any = {};
    message.msg !== undefined && (obj.msg = wiFiCtrlMsgTypeToJSON(message.msg));
    message.status !== undefined && (obj.status = statusToJSON(message.status));
    message.cmdCtrlReset !== undefined &&
      (obj.cmdCtrlReset = message.cmdCtrlReset ? CmdCtrlReset.toJSON(message.cmdCtrlReset) : undefined);
    message.respCtrlReset !== undefined &&
      (obj.respCtrlReset = message.respCtrlReset ? RespCtrlReset.toJSON(message.respCtrlReset) : undefined);
    message.cmdCtrlReprov !== undefined &&
      (obj.cmdCtrlReprov = message.cmdCtrlReprov ? CmdCtrlReprov.toJSON(message.cmdCtrlReprov) : undefined);
    message.respCtrlReprov !== undefined &&
      (obj.respCtrlReprov = message.respCtrlReprov ? RespCtrlReprov.toJSON(message.respCtrlReprov) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<WiFiCtrlPayload>, I>>(base?: I): WiFiCtrlPayload {
    return WiFiCtrlPayload.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<WiFiCtrlPayload>, I>>(object: I): WiFiCtrlPayload {
    const message = createBaseWiFiCtrlPayload();
    message.msg = object.msg ?? 0;
    message.status = object.status ?? 0;
    message.cmdCtrlReset = (object.cmdCtrlReset !== undefined && object.cmdCtrlReset !== null)
      ? CmdCtrlReset.fromPartial(object.cmdCtrlReset)
      : undefined;
    message.respCtrlReset = (object.respCtrlReset !== undefined && object.respCtrlReset !== null)
      ? RespCtrlReset.fromPartial(object.respCtrlReset)
      : undefined;
    message.cmdCtrlReprov = (object.cmdCtrlReprov !== undefined && object.cmdCtrlReprov !== null)
      ? CmdCtrlReprov.fromPartial(object.cmdCtrlReprov)
      : undefined;
    message.respCtrlReprov = (object.respCtrlReprov !== undefined && object.respCtrlReprov !== null)
      ? RespCtrlReprov.fromPartial(object.respCtrlReprov)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
